import React from "react";
import { Progress } from "semantic-ui-react";

const UploadBar = ({ percentUploaded, uploadState }) =>
    uploadState && (
        <Progress
            id="upload__bar"
            percent={percentUploaded}
            indicating
            size="tiny"
            inverted
        />
    );

export default UploadBar;
